import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';

/**
 * @typedef {import('../../App.d.ts').TextProps} TextProps
 */
/**
 * @param {TextProps} props
 */
export default (props) => {
  return (
    <Container
      standout={props.container?.standout ?? false}
      isStandaloneText={props.container?.isStandaloneText}
    >
      <div
        data-testid="text"
        dangerouslySetInnerHTML={{
          __html: props.contentRaw,
        }}
      />
    </Container>
  );
};
